"use client";

import Link from "next/link";
import { buttonClass } from "@/components/ui/button";
import { IconAlert, IconPhone } from "@/components/ui/icons";
import { useErrorTexts, useLocale, useSitePhone } from "@/components/layout/locale-context";
import { localizedPath } from "@/i18n/routes";
import { telHref } from "@/lib/utils/contact";

/** Rezervasyon sistemine ulaşılamadığında gösterilir. Boş liste veya örnek veri gösterilmez. */
export function ApiErrorState({ reset, title }: { reset?: () => void; title?: string }) {
  const locale = useLocale();
  // Site Yönetimi → Genel sayfa metinleri → Hata sayfası (bağlam yoksa yerleşik metinler)
  const t = useErrorTexts();
  // Panelde değişen telefon hata sayfasında da güncel olsun (önceden config'deki sabit numaraydı)
  const phone = useSitePhone();
  return (
    <div className="container-page py-16">
      <div role="alert" className="mx-auto max-w-xl rounded-xl bg-surface p-8 text-center shadow-card ring-1 ring-line">
        <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full bg-cta-soft text-cta-text"><IconAlert size={28} /></span>
        <h1 className="mt-4 font-heading text-2xl font-semibold text-ink">{title ?? t.title}</h1>
        <p className="mt-3 text-ink-muted">{t.text}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {reset && (
            <button type="button" onClick={reset} className={buttonClass("primary")}>
              {t.retry}
            </button>
          )}
          <a href={telHref(phone)} className={buttonClass("secondary")}>
            <IconPhone size={18} /> {phone}
          </a>
          <Link href={localizedPath(locale, "/")} className={buttonClass("ghost")}>
            {t.home}
          </Link>
        </div>
      </div>
    </div>
  );
}
